<template>
  <svg width="19" height="14" viewBox="0 0 19 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.49996 0.664062C1.21129 0.664062 0.166626 1.70873 0.166626 2.99739V11.1641C0.166626 12.4527 1.21129 13.4974 2.49996 13.4974H16.5C17.7886 13.4974 18.8333 12.4527 18.8333 11.1641V2.9974C18.8333 1.70873 17.7886 0.664062 16.5 0.664062H2.49996ZM8.33333 5.91667C8.33333 7.5275 7.0275 8.83333 5.41667 8.83333C3.80584 8.83333 2.5 7.5275 2.5 5.91667C2.5 4.30584 3.80584 3 5.41667 3C7.0275 3 8.33333 4.30584 8.33333 5.91667ZM9.5 3H16.5V5.33333H9.5V3ZM15.3333 6.5H9.5V7.66667H15.3333V6.5ZM9.5 8.83203H15.3333V9.9987H9.5V8.83203ZM7.16663 9.99609H3.66663V12.3294H7.16663V9.99609Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Metrics',
};
</script>
